import PropTypes from "prop-types";
import React from "react";
import { Alert, Button } from "react-bootstrap";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import { RectangleSpinner } from "../../../../../common/spinners";
import { ResultContent } from "./ResultContent";
import { flattenMessages } from "../../../../../intl/intlUtils";
import messages from "../../../../../intl/messages";

class PremiumSimulatorResults extends React.Component {
  renderPrintButton() {
    const { submitting, parameters } = this.props;
    if (!submitting && !!parameters) {
      const {
        memberInfo: { firstName, lastName },
      } = parameters;
      const title = `Simulation de primes - ${firstName} ${lastName}`;
      return (
        <ReactToPrint
          trigger={() => (
            <Button bsStyle="primary" className="printButton">
              <FormattedMessage id="clients.client.premiumSimulator.results.print" />
            </Button>
          )}
          content={() => this.resultContentRef}
          documentTitle={title}
        />
      );
    }
  }

  render() {
    const { error, parameters, results, submitting, client } = this.props;
    const submitted = !!parameters;
    if (!submitted) {
      return null;
    } else if (submitting) {
      return <RectangleSpinner />;
    } else if (error) {
      return (
        <Alert bsStyle="danger">
          <FormattedMessage id="clients.client.premiumSimulator.results.error" />
        </Alert>
      );
    } else {
      const {
        memberClassName,
        memberDivisionName,
      } = this.props;
      return (
        <div>
          <hr />
          {this.renderPrintButton()}
          <IntlProvider
            locale={parameters.languageCode}
            messages={flattenMessages(messages[parameters.languageCode])}
          >
            <ResultContent
              client={client}
              results={results}
              parameters={parameters}
              memberClassName={memberClassName}
              memberDivisionName={memberDivisionName}
              ref={(el) => (this.resultContentRef = el)}
            />
          </IntlProvider>
        </div>
      );
    }
  }
}

PremiumSimulatorResults.propTypes = {
  error: PropTypes.object,
  parameters: PropTypes.object,
  results: PropTypes.object,
  submitting: PropTypes.bool,
  client: PropTypes.object,
  memberClassName: PropTypes.string,
  memberDivisionName: PropTypes.string,
};

const getItemName = (itemId, itemList, idField) => {
  if (!itemId) return "";
  const items = itemList.items || [];
  const item = items.find((i) => i[idField] === itemId) || {};
  return item.name;
};

const mapStateToProps = (state) => {
  const client = state.data.clients.active;
  const premiumSimulatorData = state.premiumSimulator[client.clientId] || {};
  const submitting = premiumSimulatorData.submitting;
  const parameters = premiumSimulatorData.parameters;
  const results = premiumSimulatorData.results || {};
  const error = premiumSimulatorData.error;
  const memberCoverage = results.memberCoverage || {};
  const classId = memberCoverage.classId;
  const divisionId = memberCoverage.divisionId;
  const classes = state.data.classes || {};
  const divisions = state.data.divisions || {};
  const memberClassName = getItemName(classId, classes, "classId");
  const memberDivisionName = getItemName(divisionId, divisions, "divisionId");

  return {
    client,
    memberClassName,
    memberDivisionName,
    submitting,
    parameters,
    results,
    error,
  };
};

export default connect(mapStateToProps)(PremiumSimulatorResults);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/results/PremiumSimulatorResults.js